import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import React from 'react';

export const RentXConfirmationDialog = (props: any) => {
	const {
		updateConfirm,
		setUpdateConfirm,
		retailInput,
		setRetailInput,
	} = props;

	return (
		<>
			<CommonDialog
				fullWidth={true}
				open={updateConfirm}
				onClose={() => {
					setUpdateConfirm(false);
					setRetailInput(false);
				}}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">Confirmation</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<span className="mdDesc" style={{ whiteSpace: 'initial' }}>
								The Current Table Will Be Remove. Do you want to proceed with
								the changes?
							</span>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'No',
								props: {
									onClick: () => {
										setUpdateConfirm(false);
										setRetailInput({
											...retailInput,
											[`isRetail`]: false,
										});
									},
									variant: 'contained',
									color: 'secondary',
								},
							},
							{
								displayText: 'Yes',
								props: {
									onClick: () => {
										setUpdateConfirm(false);
									},
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
